import cx from 'classnames';

import { Button } from '@motorway/mw-highway-code';

import LinkButton from 'Components/shared/LinkButton/LinkButton';

import type { TextCTAButtonProps, TextCTAProps } from './TextCTA.types';

import styles from './TextCTA.module.scss';

const TextCTAButton: React.FC<TextCTAButtonProps> = ({ href, text, thcButtonProps }) => {
	if (href) {
		return <LinkButton href={href} label={text} />;
	}

	return <Button label={text} {...thcButtonProps} />;
};

export const TextCTA: React.FC<TextCTAProps> = ({ buttonProps, description, title }) => {
	return (
		<div className={styles.container}>
			<div className={styles.textContainer}>
				<h3 className={styles.title}>{title}</h3>
				{description && (
					<p className={cx(styles.description, { [styles.buttonSibling]: !!buttonProps })}>{description}</p>
				)}
			</div>

			{buttonProps && <TextCTAButton {...buttonProps} />}
		</div>
	);
};
